import { usePlanFundsAi } from './usePlanFundsAi'
import useLoginStore from '@/store/LoginStore'

/**
 * Returns true when AI features should be visible in the UI for the user's current
 * workspace. AI availability is TWO-FACTOR:
 *
 *   1. `aiEnabled` — the per-workspace admin kill-switch (synced via
 *      `BroadcastWorkspaceChangeAsync`, so backend toggles reflect without refetch).
 *   2. The current plan funds AI — its `aiChatTokensMonthly` / `aiEmbeddingTokensMonthly`
 *      budget is unlimited (-1) or > 0. Individual and Team fund AI (a smaller cap
 *      applies during their trial, enforced server-side); Free carries a 0 budget, so AI
 *      stays hidden there and the entry point is the upsell on the AI settings page.
 *
 * Use this to gate every AI-related surface (Smart-search tab, Ask dialog, sparkles
 * ExtractTasks button, etc). The AI settings page itself is gated on the
 * `manage_ai_settings` permission (not this hook) so admins can always reach the upsell.
 */
export function useAiAvailable(): boolean {
  const workspaceSlug = useLoginStore((s) => s.workspaceSlug)
  const workspaces = useLoginStore((s) => s.workspaces)
  const aiEnabled = Boolean(
    workspaces.find((w) => w.workspaceSlug === workspaceSlug)?.aiEnabled,
  )
  const planFundsAi = usePlanFundsAi()

  return aiEnabled && planFundsAi
}
